import { BehaviorSubject } from "rxjs";
import { showBlockInvertersAlert } from "src/components/projetos/utils/showBlockInvertersAlert";
import { showMaxInvertersAlert } from "src/components/projetos/utils/showMaxInvertersAlert";
import { showMinInvertersPowerAlert } from "src/components/projetos/utils/showMinInvertersPowerAlert";
import { showMinModulesPowerAlert } from "src/components/projetos/utils/showMinModulesPowerAlert";
import { showPopupParceiroPowerAlert } from "src/components/projetos/utils/showPopupParceiroPowerAlert";
import { getFraseParceiro } from "src/store/global.store";
import { ArrayUtil } from "../commons/ArrayUtil";
import { ListUtil } from "../commons/ListUtil";
import { showPosicaoModuloAlert } from "src/components/projetos/utils/showPosicaoModuloAlert";
import { mostrarParametroRegiaoPotenciaAlert } from "src/components/projetos/utils/mostrarParametroRegiaoPotenciaAlert";
import { mostrarPotenciaTotalMaiorQuePotenciaMaximaAlert } from "src/components/projetos/utils/mostrarPotenciaMaiorQuePotenciaMaximaAlert";
import { mostrarPotenciaTotalMenorQuePotenciaMinimaAlert } from "src/components/projetos/utils/mostrarPotenciaTotalMenorQuePotenciaMinimaAlert";

export const ALERT_POPUP_PARCEIRO = "popupParceiro";
export const ALERT_BLOCK_INVERTERS = "blockInverters";
export const ALERT_MAX_INVERTERS = "maxInverters";
export const ALERT_MIN_INVERTERS = "minInverters";
export const ALERT_MIN_MODULES = "minModules";
export const ALERT_MOSTRAR_PARAMETRO_REGIAO_POTENCIA = "mostrarParametroRegiaoPotencia";
export const ALERT_MOSTRAR_POTENCIA_TOTAL_MAIOR_QUE_POTENCIA_MAXIMA = "mostrarPotenciaTotalMaiorQuePotenciaMaxima";
export const ALERT_MOSTRAR_POTENCIA_TOTAL_MENOR_QUE_POTENCIA_MINIMA = "mostrarPotenciaTotalMenorQuePotenciaMinima";

export type TAlertsDom = {
  alert: string,
  data?: any,
}

export const alertsList$ = new BehaviorSubject<TAlertsDom[]>([]);
export const intervalAlerts$ = new BehaviorSubject<any>([]);
export const disabledAlert$ = new BehaviorSubject<boolean>(false);

export const startIntervalAlerts = async (): Promise<void> => {
    clearInterval(intervalAlerts$.getValue());

    const interval = setInterval(() => {
        
        if(disabledAlert$.getValue() === false && alertsList$.getValue().length) {
            alertGenerator();
        }
    }, 1000);

    intervalAlerts$.next(interval);
}

export const clearIntervalAlerts = async (): Promise<void> => {
    alertsList$.next([]);
    disabledAlert$.next(false);
}

const alertGenerator = async () => {
    const _alertasList = alertsList$.getValue();
    const frase = await getFraseParceiro();
    const proximoAlerta = _alertasList.shift();

    if(!proximoAlerta) {
      disabledAlert$.next(false);
    }else{
        disabledAlert$.next(true);
    }
    
    switch(proximoAlerta?.alert) {
      case ALERT_POPUP_PARCEIRO:
        showPopupParceiroPowerAlert(frase, () => {
            disabledAlert$.next(false);
            alertsList$.next(removerAlerta(alertsList$.getValue(), ALERT_POPUP_PARCEIRO));
        })
        break;
      case ALERT_BLOCK_INVERTERS:
        showBlockInvertersAlert(() => {
            disabledAlert$.next(false);
            alertsList$.next(removerAlerta(alertsList$.getValue(), ALERT_BLOCK_INVERTERS));
        });
        break;
      case ALERT_MAX_INVERTERS:
        showMaxInvertersAlert(() => {
            disabledAlert$.next(false);
            alertsList$.next(removerAlerta(alertsList$.getValue(), ALERT_MAX_INVERTERS));
        });
        break;
      case ALERT_MIN_INVERTERS:
        showMinInvertersPowerAlert(() => {
            disabledAlert$.next(false);
            alertsList$.next(removerAlerta(alertsList$.getValue(), ALERT_MIN_INVERTERS));
        });
        break;
      case ALERT_MIN_MODULES:
        showMinModulesPowerAlert(() => {
            disabledAlert$.next(false);
            alertsList$.next(removerAlerta(alertsList$.getValue(), ALERT_MIN_MODULES));
        });
        break;
      case ALERT_MOSTRAR_PARAMETRO_REGIAO_POTENCIA:
        mostrarParametroRegiaoPotenciaAlert(proximoAlerta?.data?.potencia_inicial, proximoAlerta?.data?.potencia_final, () => {
          disabledAlert$.next(false);
          alertsList$.next(removerAlerta(alertsList$.getValue(), ALERT_MOSTRAR_PARAMETRO_REGIAO_POTENCIA));
        });
        break;
      case ALERT_MOSTRAR_POTENCIA_TOTAL_MAIOR_QUE_POTENCIA_MAXIMA:
        mostrarPotenciaTotalMaiorQuePotenciaMaximaAlert(proximoAlerta?.data?.potencia_maxima, () => {
          disabledAlert$.next(false);
          alertsList$.next(removerAlerta(alertsList$.getValue(), ALERT_MOSTRAR_POTENCIA_TOTAL_MAIOR_QUE_POTENCIA_MAXIMA));
        });
        break;
      case ALERT_MOSTRAR_POTENCIA_TOTAL_MENOR_QUE_POTENCIA_MINIMA:
        mostrarPotenciaTotalMenorQuePotenciaMinimaAlert(proximoAlerta?.data?.potencia_minima, () => {
          disabledAlert$.next(false);
          alertsList$.next(removerAlerta(alertsList$.getValue(), ALERT_MOSTRAR_POTENCIA_TOTAL_MENOR_QUE_POTENCIA_MINIMA));
        });
        break;
    }

  }

  export const checkAlerts = (_alertsList: string[], alert: string): string[] => {
    if(!ArrayUtil.contains(_alertsList, alert)) {
      _alertsList.push(alert);
    }

    return _alertsList;
  }

  export const stopIntervalAlerts = () => {
    clearIntervalAlerts();
    if(intervalAlerts$.getValue())  {
      clearInterval(intervalAlerts$.getValue());
    }
  }

  export const setAlertsList = (_alertsList: TAlertsDom[]) => {
    alertsList$.next(ListUtil.removeDuplicates(_alertsList));
  }

  export const setAlert = (alert: string, data?: any) => {
    const _alertsList = alertsList$.getValue();
    _alertsList.push({
      alert,
      data,
    });

    setAlertsList(_alertsList);
  }

  const removerAlerta = (_alertsList: any[], alerta: string) => {
    const alertasStringList = ArrayUtil.removeItem(_alertsList.map(a => a.alert), alerta);
    return _alertsList.map(a => {
      if(ArrayUtil.contains(alertasStringList, a.alert)) {
        return a;
      }
    }).filter(Boolean);
  }